import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  LayoutDashboard,
  Search,
  ClipboardList,
  CalendarDays,
  Target,
  Users,
  Settings
} from 'lucide-react';

const MobileBottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { activePortal } = useAuth();
  
  const isAgentPage = location.pathname.startsWith('/agent');
  const isAdminPage = location.pathname.startsWith('/admin');
  
  if (!isAgentPage && !isAdminPage) return null;

  // Admin bottom nav items (5 most used)
  const adminItems = [
    { to: '/admin', icon: LayoutDashboard, label: 'Dashboard' },
    { to: '/admin/opportunites', icon: Target, label: 'Opportunités' },
    { to: '/admin/agents', icon: Users, label: 'Agents' },
    { to: '/admin/agenda', icon: CalendarDays, label: 'Agenda' },
    { to: '/admin/cee-settings', icon: Settings, label: 'Paramètres' },
  ];

  // Agent bottom nav items
  const agentItems = [
    { to: '/agent', icon: LayoutDashboard, label: 'Dashboard' },
    { to: '/agent/recherche', icon: Search, label: 'Recherche' },
    { to: '/agent/prospection', icon: ClipboardList, label: 'Prospects' },
    { to: '/agent/agenda', icon: CalendarDays, label: 'Agenda' },
  ];

  const items = isAdminPage ? adminItems : agentItems;

  const isActive = (to) => {
    if (to === '/admin' || to === '/agent') {
      return location.pathname === to;
    }
    return location.pathname.startsWith(to);
  };

  return (
    <nav className="mobile-bottom-nav" data-testid="mobile-bottom-nav">
      {items.map((item) => (
        <button
          key={item.to}
          onClick={() => navigate(item.to)}
          className={`mobile-bottom-nav-item ${isActive(item.to) ? 'active' : ''}`}
          data-testid={`bottom-nav-${item.label.toLowerCase()}`}
        >
          <item.icon strokeWidth={isActive(item.to) ? 2.5 : 1.5} />
          <span>{item.label}</span>
        </button>
      ))}
    </nav>
  );
};

export default MobileBottomNav;
